This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="basicBlock withHeaderBeam">
    <p class="header upper">{{ $t("levelMaker.settings") }}</p>
    <div class="changeName">
      <input
        id="nameBundle"
        class="input noUpperBorder"
        :placeholder="$t('levelMaker.levelName')"
        v-model="levelName"
        @input="updateName"
        autocomplete="off"
      />
    </div>
    <div class="spaceAbove">
      <div class="blockEntry grid grid-cols-2 constraints">
        <p>
          {{ $t(`levelMaker.theme`) }}
        </p>
        <div class="buttonsRight">
          <select id="theme" v-model="levelTheme" class="dropdown">
            <option value="farm">{{ $t(`levelMaker.themes.farm`) }}</option>
            <option value="desert">{{ $t(`levelMaker.themes.desert`) }}</option>
          </select>
        </div>
      </div>
      <div class="seed">
        <input
          id="seed"
          class="input noUpperBorder"
          placeholder="Seed... "
          @input="updateSeed"
          v-model="levelSeed"
          autocomplete="off"
        />
        <div class="tooltip">
          <button class="button neutral" @click="generateSeed">
            <img
              src="@/assets/images/icons/Back.svg"
              alt="Generate new seed icon"
            />
          </button>
          <div class="tooltipText left -left-7">
            <p>{{ $t("levelMaker.seedGen") }}</p>
            <i></i>
          </div>
        </div>
      </div>
    </div>
    <div class="spaceAbove">
      <div
        v-for="constraint in constraints"
        :key="constraint.langid"
        class="blockEntry grid grid-cols-2 constraints"
      >
        <p>
          {{ $t(`levelMaker.${constraint.langid}`) }}
        </p>
        <div class="buttonsRight">
          <label class="toggle">
            <input
              type="checkbox"
              class="base"
              v-model="constraint.value"
              :checked="constraint.value"
              autocomplete="off"
            />
            <div class="background"></div>
            <div class="button"></div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { userAPI } from "@/utils/apiCalls";
import { store } from "@/store";

@Options({
  data() {
    return {
      levelName: "",
      levelTheme: "farm",
      levelSeed: "",
    };
  },
  watch: {
    //Update theme on level theme change
    levelTheme() {
      this.updateTheme();
    },
  },
  methods: {
    //Update database
    updateDatabase(): void {
      userAPI.setUserPreferences(this.$store.getters.getPreferences);
    },
    //Update level name
    updateName(): void {
      console.log('levelname', this.levelName);
      store.commit("setLevelMakerName", this.levelName);
    },
    //Update level theme
    updateTheme() {
      store.commit("setLevelMakerTheme", this.levelTheme);
    },
    //Generate level seed
    generateSeed() {
      this.levelSeed = Math.floor(Math.random() * 999999999);
    },
    //Update level seed
    updateSeed() {
      this.levelSeed = this.levelSeed
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
      store.commit("setLevelMakerSeed", this.levelSeed);
    },
  },
  computed: {
    //Get and set level constraints
    constraints: {
      get(): { name: string; langid: string; value: boolean }[] {
        return store.getters.getLevelMakerConstraints;
      },
      set(value: { name: string; langid: string; value: boolean }[]) {
        store.commit("setLevelMakerConstraints", value);
      },
    },
  },
  mounted() {
    this.levelName = store.getters.getLevelMakerName;
    this.levelSeed = store.getters.getLevelMakerSeed;
    this.levelTheme = store.getters.getLevelMakerTheme;
  },
  beforeMount() {
    this.soundEnabled = this.$store.getters.getPreferences.soundEnabled;
    this.musicEnabled = this.$store.getters.getPreferences.musicEnabled;
  },
})
export default class LevelMakerSettings extends Vue {}
</script>
